// extracted by mini-css-extract-plugin
export default {"help":"styles_help__hMUiH","sbp-logo":"styles_sbp-logo__nHGxq","title":"styles_title__5vrnb","recovery-link":"styles_recovery-link__oJKcC"};